<template>
    <DxDataGridOscilos :oscilosProp="oscilos" :vistaAdministracionProp="vistaAdministracion"
        @IdInstalacionChanged="onIdInstalacionChanged" @DxDataGridFilterChanged="onDxDataGridFilterChanged" />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import type { OsciloDetalleModel } from '@/.shared/.api';
import type CustomStore from 'devextreme/data/custom_store';
import DxDataGridOscilos from '@/components/oscilos/DxDataGridOscilos.vue';
const emit = defineEmits(['IdInstalacionChanged', 'DxDataGridFilterChanged']);

const props = defineProps<{ oscilosProp: OsciloDetalleModel[] | CustomStore, vistaAdministracionProp: boolean }>();
const oscilos = computed(() => props.oscilosProp); // cuando cambie props.oscilos, coge todos los items de la template donde se use dataSource y los recarga
const vistaAdministracion = computed(() => props.vistaAdministracionProp);

function onIdInstalacionChanged(idInstalacionSeleccionada: number | undefined) {
    emit('IdInstalacionChanged', idInstalacionSeleccionada);
}

function onDxDataGridFilterChanged() {
    emit('DxDataGridFilterChanged');
}
</script>